import { ErrorState } from '../ui/States';
import screen from './screen.module.css';

/** A screen that throws while rendering, or a chunk that fails to load: say so, keep the nav, offer one retry (DESIGN_SYSTEM §10, no dead ends). */
export function CrashScreen() {
  return (
    <div className={screen.screen}>
      <h1 className="t-title">Something went wrong</h1>
      <ErrorState
        problem="This screen stopped working."
        fix="Your projects, kits, marks and sounds are saved on this phone. Try again, or use the tabs below."
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
